import type {ExploreNode} from "../types/categoryProfileTypes";
import {labelsOf} from "./exploreTree";

export type CategoryHit = {path: string; name: string; trail: string; level: number; spend: number};

/** Every node of the tree, flat, with its parent trail ("Facilities › Cleaning"). */
export function searchIndex(tree: ExploreNode[]): CategoryHit[] {
    const out: CategoryHit[] = [];
    const walk = (nodes: ExploreNode[]) => nodes.forEach(n => {
        out.push({path: n.path, name: n.name, trail: labelsOf(n.path).slice(0, -1).join(' › '), level: n.level, spend: n.spend});
        walk(n.children);
    });
    walk(tree);
    return out;
}

/**
 * Categories matching every word of `query` (case-insensitive) in their name or trail. Name matches first, then
 * names that start with the query, then by spend.
 */
export function matchCategories(index: CategoryHit[], query: string, limit = 12): CategoryHit[] {
    const words = query.toLowerCase().split(/\s+/).filter(Boolean);
    if (!words.length) return [...index].sort((a, b) => a.level - b.level || b.spend - a.spend).slice(0, limit);
    const q = words.join(' ');
    return index
        .filter(h => words.every(w => `${h.name} ${h.trail}`.toLowerCase().includes(w)))
        .map(h => {
            const name = h.name.toLowerCase();
            const rank = name.startsWith(q) ? 0 : words.every(w => name.includes(w)) ? 1 : 2;
            return {h, rank};
        })
        .sort((a, b) => a.rank - b.rank || b.h.spend - a.h.spend)
        .slice(0, limit)
        .map(x => x.h);
}
